import type { Profile } from '~/types/profile'
import { useProfileStore } from '~/stores/user/Profile'
import { useProfileSelfStore } from '~/stores/user/Self'

export async function markAsActive() {
	const profileSelfStore = useProfileSelfStore()
	await profileSelfStore().isActive()
}

export function location(profile: Profile) {
	if (profile.city && profile.country) {
		return `${profile.city}, ${profile.country}`
	} else if (profile.city) {
		return profile.city
	} else if (profile.country) {
		return profile.country
	} else {
		return 'Unknown'
	}
}

export function joined_at(profile: Profile) {
	return ago(profile.created_at)
}

export function active_at(profile: Profile) {
	return ago(profile.active_at)
}

export async function usernameCheck(username: string, profile: Profile) {
	const profileStore = useProfileStore(username)
	const existingUsers = <Profile>await profileStore().getByUsername()
	if (existingUsers && existingUsers?.id !== profile.id) {
		return true
	}
	return false
}


